import { useMemo } from 'react';
import useCachedSearchCriteria from './useCachedSearchCriteria';
import {
  DEPART_DATE,
  DEPARTING,
  RETURN_DATE,
  RETURNING,
  tripTypeValues,
} from '../constants';

const useDynamicSearchCriteria = (flightSearchCriteria, tabDates) => {
  const dynamicCriteria = useMemo(
    () => ({
      flightSearchCriteria: {
        ...flightSearchCriteria,
        ...getDateCriteriaFromTabState(tabDates, flightSearchCriteria),
      },
    }),
    [flightSearchCriteria, tabDates]
  );

  return useCachedSearchCriteria(dynamicCriteria);
};

const getDateCriteriaFromTabState = (tabDates, flightSearchCriteria) => {
  return {
    [DEPART_DATE]: {
      date:
        tabDates[DEPARTING]?.selected || flightSearchCriteria.departDate?.date,
      plusDays: 0,
      minusDays: 0,
    },
    [RETURN_DATE]:
      flightSearchCriteria.tripType !== tripTypeValues.ONEWAY
        ? {
            date:
              tabDates[RETURNING]?.selected ||
              flightSearchCriteria.returnDate?.date,
            plusDays: 0,
            minusDays: 0,
          }
        : null,
  };
};

export default useDynamicSearchCriteria;
